import React from "react";
import { SearchableSelect } from "../SearchableSelect";

// Type-specific sections: delivery, advance, repair, job work, transport / e-way, notes & accounting posting.
export function DocExtraSections({ form, setForm, cfg, showPosting, ledgers }) {
  return (
  <div className="md:col-span-2 space-y-4">
    {cfg.showDelivery && (
      <div className="card-base p-5">
        <div className="font-display font-semibold mb-3">Delivery Schedule</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div>
            <div className="label-overline block mb-1.5">Expected Delivery Date</div>
            <input type="date" className="field" data-testid="doc-expected-delivery" value={form.expected_delivery_date || ""} onChange={e => setForm({ ...form, expected_delivery_date: e.target.value })} />
          </div>
        </div>
      </div>
    )}

    {cfg.showAdvance && (
      <div className="card-base p-5">
        <div className="font-display font-semibold mb-3">Advance Received</div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-3">
          <div>
            <div className="label-overline block mb-1.5">Amount (₹)</div>
            <input type="number" step="0.01" className="field text-right" data-testid="doc-advance-amount" value={form.advance_amount} onChange={e => setForm({ ...form, advance_amount: e.target.value })} />
          </div>
          <div>
            <div className="label-overline block mb-1.5">Mode</div>
            <select className="field" data-testid="doc-advance-mode" value={form.advance_mode} onChange={e => setForm({ ...form, advance_mode: e.target.value })}>
              <option value="">—</option>
              <option>Cash</option><option>UPI</option><option>Bank</option><option>Cheque</option><option>Card</option><option>Other</option>
            </select>
          </div>
          <div className="md:col-span-2">
            <div className="label-overline block mb-1.5">Reference / Txn ID</div>
            <input className="field" data-testid="doc-advance-ref" value={form.advance_reference} onChange={e => setForm({ ...form, advance_reference: e.target.value })} />
          </div>
        </div>
      </div>
    )}

    {cfg.showRepair && (
      <div className="card-base p-5">
        <div className="font-display font-semibold mb-3">Repair Details</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div><div className="label-overline block mb-1.5">Item / Machine (Make & Model)</div><input className="field" data-testid="repair-make" value={form.item_make_model} onChange={e => setForm({ ...form, item_make_model: e.target.value })} /></div>
          <div><div className="label-overline block mb-1.5">Serial Number</div><input className="field font-mono" data-testid="repair-serial" value={form.serial_number} onChange={e => setForm({ ...form, serial_number: e.target.value })} /></div>
          <div className="md:col-span-2"><div className="label-overline block mb-1.5">Issue / Repair Description</div><textarea rows={2} className="field" data-testid="repair-issue" value={form.issue_description} onChange={e => setForm({ ...form, issue_description: e.target.value })} /></div>
        </div>
      </div>
    )}

    {cfg.showJobWork && (
      <div className="card-base p-5">
        <div className="font-display font-semibold mb-3">Job Work Details</div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          <div><div className="label-overline block mb-1.5">Item / Machine (Make & Model)</div><input className="field" data-testid="jw-make" value={form.item_make_model} onChange={e => setForm({ ...form, item_make_model: e.target.value })} /></div>
          <div><div className="label-overline block mb-1.5">Serial Number</div><input className="field font-mono" data-testid="jw-serial" value={form.serial_number} onChange={e => setForm({ ...form, serial_number: e.target.value })} /></div>
          <div><div className="label-overline block mb-1.5">Purpose of Job Work</div>
            <select className="field" data-testid="jw-purpose" value={form.purpose_of_job_work} onChange={e => setForm({ ...form, purpose_of_job_work: e.target.value })}>
              <option value="">Select</option>
              <option>Repair</option>
              <option>Servicing</option>
              <option>Machining</option>
              <option>Fabrication</option>
              <option>Calibration</option>
              <option>Testing</option>
              <option>Other</option>
            </select>
          </div>
          <div>
            <div className="label-overline block mb-1.5">Expected Return Date</div>
            <input type="date" className="field" data-testid="jw-return" value={form.expected_return_date || ""} onChange={e => setForm({ ...form, expected_return_date: e.target.value })} />
          </div>
          <div><div className="label-overline block mb-1.5">Condition at Dispatch</div>
            <select className="field" value={form.item_condition} onChange={e => setForm({ ...form, item_condition: e.target.value })}>
              <option>Good</option><option>Damaged</option><option>Partially Working</option><option>Not Working</option>
            </select>
          </div>
          <div className="flex items-center gap-2 pt-6">
            <input type="checkbox" id="returnable" checked={!!form.is_returnable} onChange={e => setForm({ ...form, is_returnable: e.target.checked })} />
            <label htmlFor="returnable" className="text-sm">Returnable (will come back)</label>
          </div>
        </div>
      </div>
    )}

    {cfg.showTransport && (
      <div className="card-base p-5">
        <div className="font-display font-semibold mb-3">Transport {cfg.showEway ? "& E-Way Bill" : ""}</div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
          <div><div className="label-overline block mb-1.5">Transporter</div><input className="field" value={form.transporter_name} onChange={e => setForm({ ...form, transporter_name: e.target.value })} data-testid="doc-transporter" /></div>
          <div><div className="label-overline block mb-1.5">Transporter ID</div><input className="field font-mono" value={form.transporter_id} onChange={e => setForm({ ...form, transporter_id: e.target.value })} /></div>
          <div><div className="label-overline block mb-1.5">Vehicle No</div><input className="field font-mono uppercase" value={form.vehicle_no} onChange={e => setForm({ ...form, vehicle_no: e.target.value.toUpperCase() })} data-testid="doc-vehicle" /></div>
          <div><div className="label-overline block mb-1.5">Mode</div>
            <select className="field" value={form.transport_mode} onChange={e => setForm({ ...form, transport_mode: e.target.value })}>
              <option>Road</option><option>Rail</option><option>Air</option><option>Ship</option>
            </select>
          </div>
          <div><div className="label-overline block mb-1.5">Distance (KM)</div><input type="number" className="field" value={form.distance_km} onChange={e => setForm({ ...form, distance_km: e.target.value })} data-testid="doc-distance" /></div>
          {cfg.showEway && <div><div className="label-overline block mb-1.5">E-Way Bill No</div><input className="field font-mono" value={form.eway_bill_no} onChange={e => setForm({ ...form, eway_bill_no: e.target.value })} /></div>}
          {cfg.showGatePass && <>
            <div><div className="label-overline block mb-1.5">Driver Name</div><input className="field" value={form.driver_name} onChange={e => setForm({ ...form, driver_name: e.target.value })} /></div>
            <div><div className="label-overline block mb-1.5">Purpose</div>
              <select className="field" value={form.gate_pass_purpose} onChange={e => setForm({ ...form, gate_pass_purpose: e.target.value })}>
                <option>Outward</option><option>Inward</option><option>Returnable</option>
              </select>
            </div>
          </>}
        </div>
      </div>
    )}

    <div className="card-base p-5">
      <div className="font-display font-semibold mb-3">Notes & Terms</div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div><div className="label-overline block mb-1.5">Notes</div><textarea rows={3} className="field" value={form.notes} onChange={e => setForm({ ...form, notes: e.target.value })} data-testid="doc-notes" /></div>
        {showPosting && ledgers.length > 0 && (
          <div className="border border-dashed border-border rounded-md p-3 space-y-2">
            <div className="label-overline">Accounting Posting (optional — Tally ledgers)</div>
            <div>
              <div className="text-[10px] text-ink-muted mb-1">Ledger to DEBIT (default: customer ledger)</div>
              <SearchableSelect testId="doc-dr-ledger" placeholder="Auto — customer ledger"
                options={[{ value: "", label: "Auto — customer ledger" }, ...ledgers.map(l => ({ value: l.id, label: `${l.name} (${l.group_name})` }))]}
                value={form.dr_ledger_id} onChange={v => setForm({ ...form, dr_ledger_id: v })} />
            </div>
            <div>
              <div className="text-[10px] text-ink-muted mb-1">Ledger to CREDIT (default: Sales A/c)</div>
              <SearchableSelect testId="doc-cr-ledger" placeholder="Auto — Sales A/c"
                options={[{ value: "", label: "Auto — Sales A/c" }, ...ledgers.map(l => ({ value: l.id, label: `${l.name} (${l.group_name})` }))]}
                value={form.cr_ledger_id} onChange={v => setForm({ ...form, cr_ledger_id: v })} />
            </div>
            <div className="text-[10px] text-ink-muted">GST output ledgers post automatically. Voucher visible in Accounting → Day Book.</div>
          </div>
        )}
        <div><div className="label-overline block mb-1.5">Terms & Conditions</div><textarea rows={3} className="field" value={form.terms} onChange={e => setForm({ ...form, terms: e.target.value })} data-testid="doc-terms" /></div>
      </div>
    </div>
  </div>
  );
}
